module.exports = __webpack_public_path__ + "static/media/starcom.8fd83573.png";